import React, { useState } from 'react';
import { navLinks, siteConfig } from '../data/mockData';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import BookingModal from './BookingModal';

const Header = ({ onBookNow }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 bg-white z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_cenwi-dumpsters/artifacts/as0yrnig_ChatGPT%20Image%20Jan%2023%2C%202026%2C%2002_46_35%20PM.png" 
              alt="Dump Trailer Dude"
              className="h-16 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-gray-600 hover:text-[#22C55E] transition-colors duration-200 text-sm font-medium"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* CTA Section */}
          <div className="hidden lg:flex items-center space-x-4">
            <Button 
              onClick={onBookNow}
              className="bg-[#22C55E] hover:bg-[#16A34A] text-white px-6 py-2 rounded-md font-semibold transition-all duration-200"
            >
              Book Now
            </Button>
            <a 
              href={`tel:${siteConfig.phone}`}
              className="flex items-center space-x-2 text-gray-700 hover:text-[#22C55E] transition-colors"
            >
              <Phone className="w-5 h-5 text-[#22C55E]" />
              <span className="font-semibold">{siteConfig.phoneFormatted}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="block text-gray-600 hover:text-[#22C55E] py-2 text-sm font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <div className="pt-4 border-t space-y-3">
              <Button 
                onClick={() => {
                  setMobileMenuOpen(false);
                  onBookNow();
                }}
                className="w-full bg-[#22C55E] hover:bg-[#16A34A] text-white py-2 rounded-md font-semibold"
              >
                Book Now
              </Button>
              <a 
                href={`tel:${siteConfig.phone}`}
                className="flex items-center justify-center space-x-2 text-gray-700 py-2"
              >
                <Phone className="w-5 h-5 text-[#22C55E]" />
                <span className="font-semibold">{siteConfig.phoneFormatted}</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
